export interface Product {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number;
  currency: string;
  interval?: 'month' | 'year';
}

export const products: Product[] = [
  {
    id: 'prod_SSfJOg1FKFv8mA',
    priceId: 'price_1RXjyPCt1ZkIwtocZYwrBdbf',
    name: 'Awakening Soul',
    description: 'Unlock your manifestation potential with our premium commitment level',
    mode: 'subscription',
    price: 11.11,
    currency: 'usd',
    interval: 'month'
  },
  {
    id: 'prod_aligned',
    priceId: 'price_1RXjyvCt1ZkIwtochrmfTvnO',
    name: 'Aligned Manifestor',
    description: 'Align with universal abundance through bi-weekly guidance',
    mode: 'subscription',
    price: 22.22,
    currency: 'usd',
    interval: 'month'
  },
  {
    id: 'prod_abundant',
    priceId: 'price_1RXjzRCt1ZkIwtocFcxYcLEo',
    name: 'Abundant Creator',
    description: 'Create unlimited abundance with daily divine connection',
    mode: 'subscription',
    price: 88.88,
    currency: 'usd',
    interval: 'month'
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductByPriceId = (priceId: string): Product | undefined => {
  return products.find(product => product.priceId === priceId);
};